module.exports = __webpack_public_path__ + "static/img/1692694640464.26f82a0a.jpg";